import { useEffect, useState } from 'react';
import { apiClient } from '../../services/http.js';
import { fetchPlanCatalog } from '../../services/planCatalog.js';
import { PlanGrid } from './PlanGrid.jsx';

export function PlansPage() {
    const [currentPlanId, setCurrentPlanId] = useState(null);
    const [plans, setPlans] = useState([]);

    useEffect(() => {
        fetchPlanCatalog().then(setPlans);
    }, []);

    useEffect(() => {
        apiClient.request('/billing/credits')
            .then(({ res, data }) => {
                if (res.ok && data?.plan) {
                    setCurrentPlanId(data.plan);
                }
            })
            .catch(() => null);
    }, []);



    return (
        <>
            <div className="max-w-6xl mx-auto p-6">
                <h1 className="text-4xl font-bold text-center mb-8">Escolha seu Plano</h1>
                <PlanGrid plans={plans} currentPlanId={currentPlanId} />
            </div>
        </>
    );
}
